import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Children, cloneElement } from 'react';
import { HelpText } from '../help-text';
import { Label, LabelType } from '../label';
const b = bemClassBuilder('v-fieldset');
/**
 * Renders a fieldset that wraps an radio/checkbox group, optional label and optional help text.
 * Passes the style attribute down to any children.
 * Note: You should use a Fieldset for Checkbox Groups and Radio Groups, and use Field for all other input types.
 */
export const Fieldset = observer(props => {
    var _a;
    const { id, name, label, optional, helpText, style, className, children } = props;
    const helpTextId = `${id}_help-text`;
    const showLabel = (_a = props.showLabel) !== null && _a !== void 0 ? _a : !!label;
    const inputProps = { style, name };
    const childrenWithExtraProps = children
        ? Children.map(children, child => cloneElement(child, inputProps))
        : [];
    return (_jsxs("fieldset", Object.assign({ className: b.block(undefined, className), id: id }, { children: [showLabel && _jsx(Label, { text: label, type: LabelType.Legend, optional: optional, style: style }), childrenWithExtraProps, helpText && _jsx(HelpText, { id: helpTextId, style: style, text: helpText })] })));
});
Fieldset.displayName = 'Fieldset';
